export { default } from './TestimonialList.js';
